if (process.env.SERVER === 'production') {
  module.exports = require('./config.prod')
} else if (process.env.SERVER === 'staging') {
  module.exports = require('./config.stage')
} else if (process.env.SERVER === 'local') {
  module.exports = require('./config.local')
} else {
  module.exports = require('./config.dev')
}
